<template>
  <div v-if="isMounted">
    <svg
      :style="[{ 'pointer-events': readOnly ? 'none' : 'fill' }]"
      :height="height"
      :width="width"
      fill="none"
      viewBox="0 0 422 1200"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        @click="eventClickOnGerericAreas(areas.face)"
        @mouseover="activeArea = areas.face"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.face.selected ? areas.face.activeColor : areas.face.inactiveColor"
        :class="{ active: data.face.selected, hovered: activeArea == areas.face }"
        class="ax-selectable"
        stroke="black"
        d="M250.629 6.90542C266.708 16.9357 272.356 22.7849 279.629 33.4054C282.796 38.5721 287.729 56.6054 282.129 87.4054C286.529 83.0054 289.454 87.8993 289.629 88.9054C293.368 110.405 279.129 117.405 279.629 124.905C279.629 127.905 278.229 133.805 272.629 133.405C270.229 140.205 269.962 144.572 270.129 145.905C269.796 148.405 267.729 154.405 262.129 158.405C231.384 183.453 213.688 183.898 181.256 158.905C175.656 154.905 173.589 148.905 173.256 146.405C173.422 145.072 173.156 140.705 170.756 133.905C165.156 134.305 163.756 128.405 163.756 125.405C164.256 117.905 150.016 110.905 153.756 89.4053C153.93 88.3992 156.856 83.5054 161.256 87.9054C155.656 57.1054 160.589 39.072 163.756 33.9054C171.028 23.2848 176.677 17.4356 192.756 7.40536C216.204 -1.07377 228.863 -1.02674 250.629 6.90542Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.face)"
        @mouseover="activeArea = areas.face"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M282.129 87.4054C287.729 56.6054 282.796 38.5721 279.629 33.4054C272.356 22.7849 266.708 16.9357 250.629 6.90542C228.863 -1.02674 216.204 -1.07377 192.756 7.40536C176.677 17.4356 171.028 23.2848 163.756 33.9054C160.589 39.072 155.656 57.1054 161.256 87.9054M282.129 87.4054C286.529 83.0054 289.454 87.8993 289.629 88.9054C293.368 110.405 279.129 117.405 279.629 124.905C279.629 127.905 278.229 133.805 272.629 133.405M282.129 87.4054C280.552 75.2956 280.235 70.4438 272.629 59C266.897 56.539 263.807 54.5955 258.5 57M282.129 87.4054C282.129 88.9959 282.066 90.5238 281.951 92M272.629 133.405C270.229 140.205 269.962 144.572 270.129 145.905C269.796 148.405 267.729 154.405 262.129 158.405C231.384 183.453 213.688 183.898 181.256 158.905C175.656 154.905 173.589 148.905 173.256 146.405C173.422 145.072 173.156 140.705 170.756 133.905M272.629 133.405C273.135 126.794 274.563 121.261 276.162 116M161.256 87.9054C156.856 83.5054 153.93 88.3992 153.756 89.4053C150.016 110.905 164.256 117.905 163.756 125.405C163.756 128.405 165.156 134.305 170.756 133.905M161.256 87.9054C165.343 72.2652 168.764 64.1036 178.5 51.5C186.542 45.8537 189.488 41.9139 192.756 33.9054C205.558 44.0996 215.865 49.9777 228.5 53.2859M161.256 87.9054C161.256 89.5877 161.358 91.2876 161.542 93M170.756 133.905C170.231 127.884 168.485 121.497 166.631 115M258.5 57C246.485 56.5661 236.969 55.5034 228.5 53.2859M258.5 57C245.053 52.059 245.257 44.6094 244.5 32M192.756 12.5C191.74 18.7831 190.333 22.2108 191.5 28M218 22.5C217.68 40.8354 221.144 45.9113 228.5 53.2859M217.5 156C221.212 154.332 223.288 154.375 227 156M201 149C201.86 147.554 202.078 146.68 202 145M204 147.5C219 146.405 228.393 149.905 239.5 147.5M258.5 145C257.492 146.499 257.256 147.477 257.5 149.5M230.5 132C226 134 225.114 132.593 222.5 135.5L230.5 132ZM230.5 132C230.091 128.014 231 124.5 227 123M225 91.5C222.5 101 224 109 225 119.5M235.5 81.5C254 81.5 255.377 73.2446 270.129 84.5M210.5 81.5C193 83 186.5 75 171.5 85.5M201 96C199 96 197.5 94.5 197.5 92.5C197.5 91.4461 197.917 90.531 198.603 89.9011M201 96C203 96 204.5 94.5 204.5 92.5C204.5 91.5603 204.169 90.7309 203.61 90.1157M201 96C198.724 94.5395 197.971 93.3621 198.603 89.9011M201 96C203.436 94.277 204.129 93.0381 203.61 90.1157M209.5 92C207.469 91.0258 205.54 90.426 203.61 90.1157M185 92.5C190.378 91.2255 194.656 90.1419 198.603 89.9011M198.603 89.9011C198.858 89.8855 199.112 89.8735 199.364 89.8651M203.61 90.1157C203.44 90.0883 203.269 90.0631 203.099 90.0401M234 92C236.29 91.1793 238.293 90.6158 240.233 90.3021M257 92.5C252.253 91.101 248.733 90.2788 245.561 90.0626M245.561 90.0626C246.149 90.6828 246.5 91.533 246.5 92.5C246.5 94.5 245 96 243 96C241 96 239.5 94.5 239.5 92.5C239.5 91.6521 239.77 90.8941 240.233 90.3021M245.561 90.0626C245.901 91.2283 245.886 91.8749 245 93C243.455 94.2836 242.568 94.8005 241 93C240.38 92.4372 240.266 91.7642 240.233 90.3021M245.561 90.0626C246 93.5 245 95 243 95C241 95 239.969 93.9663 240.233 90.3021M245.561 90.0626C245.021 91.7871 244.69 93.2174 243 93.5M245.561 90.0626L243 93.5M245.561 90.0626C245.203 90.0382 244.85 90.0215 244.5 90.0126M240.233 90.3021C241.257 92.154 241.841 93.5497 243 93.5M240.233 90.3021L243 93.5M240.233 90.3021C240.657 90.2334 241.079 90.1767 241.5 90.1319M241.5 90.1319L243 92.5L244.5 90.0126M241.5 90.1319C241.76 90.1043 242.019 90.0812 242.278 90.0626M244.5 90.0126C244.249 90.0062 244 90.0038 243.753 90.0054M243 90.0225C242.759 90.032 242.519 90.0454 242.278 90.0626M243 90.0225L242.278 90.0626M243 90.0225C243.25 90.0127 243.501 90.007 243.753 90.0054M242.278 90.0626L243 91L243.753 90.0054M199.364 89.8651C199.009 92.8302 199.484 93.8421 201 95C202.631 93.57 203.127 92.5068 203.099 90.0401M199.364 89.8651C199.66 89.8553 199.954 89.8506 200.248 89.8512M203.099 90.0401C202.832 90.0042 202.564 89.9737 202.297 89.9483M200.248 89.8512C200.112 91.979 200.339 93.1774 201 94C202.017 92.6554 202.337 91.7848 202.297 89.9483M200.248 89.8512C200.447 89.8517 200.647 89.8546 200.845 89.8601M202.297 89.9483C202.15 89.9344 202.003 89.922 201.856 89.9112M200.845 89.8601L201 93L201.856 89.9112M200.845 89.8601C201.184 89.8695 201.52 89.8864 201.856 89.9112M161.542 93C157.223 92.8609 156.305 95.1551 158 104.5M161.542 93C162.317 100.23 164.543 107.685 166.631 115M162.5 111C161.696 112.746 161.761 113.606 162.5 115C163.417 116.35 164.298 116.328 166.631 115M281.951 92C285.871 92.0342 286.126 95.32 285.5 103M281.951 92C281.237 101.118 278.514 108.265 276.162 116M276.162 116C278.065 115.844 279.227 115.384 281.951 112M214 134C216.249 133.657 217.332 133.903 219 135C217.96 133.851 217.354 133.212 214.5 132.5C214.5 132.5 213 132.5 212.5 133.5C212 134.5 214 134 214 134Z"
        stroke="black"
        fill="none"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_right_lower_arm)"
        @mouseover="activeArea = areas.front_right_lower_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        stroke="black"
        :fill="
          data.front_right_lower_arm.selected
            ? areas.front_right_lower_arm.activeColor
            : areas.front_right_lower_arm.inactiveColor
        "
        :class="{ active: data.front_right_lower_arm.selected, hovered: activeArea == areas.front_right_lower_arm }"
        class="ax-selectable"
        d="M411.5 612C411.5 550.5 422.233 492.905 399.233 416.405L340.733 433.405C337.733 508.905 359.233 545.405 375.733 592.905C377.406 598.934 375.339 602.716 374 607.5L411.5 612Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_right_lower_arm)"
        @mouseover="activeArea = areas.front_right_lower_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M359.5 440C369.942 433.997 376.174 431.57 389 431.5M399.233 416.405C422.233 492.905 411.5 550.5 411.5 612L374 607.5C375.339 602.716 377.406 598.934 375.733 592.905C359.233 545.405 337.733 508.905 340.733 433.405L399.233 416.405Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_left_upper_arm)"
        @mouseover="activeArea = areas.front_left_upper_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        stroke="black"
        :fill="
          data.front_left_upper_arm.selected
            ? areas.front_left_upper_arm.activeColor
            : areas.front_left_upper_arm.inactiveColor
        "
        :class="{ active: data.front_left_upper_arm.selected, hovered: activeArea == areas.front_left_upper_arm }"
        class="ax-selectable"
        d="M111.129 349.905L55.629 310.405C56.2447 302.278 56.3764 296.706 55.629 278.905C58.4416 239.122 68.6277 225.374 103.129 213.405C126.629 282.905 108.129 325.905 111.129 349.905Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_left_middle_arm)"
        @mouseover="activeArea = areas.front_left_middle_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        stroke="black"
        :fill="
          data.front_left_middle_arm.selected
            ? areas.front_left_middle_arm.activeColor
            : areas.front_left_middle_arm.inactiveColor
        "
        :class="{ active: data.front_left_middle_arm.selected, hovered: activeArea == areas.front_left_middle_arm }"
        class="ax-selectable"
        d="M44.129 417.405C48.629 391.905 41.9911 350.184 55.629 310.405L111.129 349.905C111.739 363.232 112.471 370.029 113.629 382.405C106.629 393.905 113.629 409.405 102.629 434.405L44.129 417.405Z"
      />

      <path
        @click="eventClickOnGerericAreas(areas.front_upper_chest)"
        @mouseover="activeArea = areas.front_upper_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_upper_chest.selected ? areas.front_upper_chest.activeColor : areas.front_upper_chest.inactiveColor
        "
        :class="{ active: data.front_upper_chest.selected, hovered: activeArea == areas.front_upper_chest }"
        d="M111.629 327.905C118.129 282.905 117.129 255.905 103.129 213.405L174.629 186.405C179.197 177.805 180.67 171.941 181.129 159.405C214.437 184.448 232.103 183.417 262.129 159.405C262.371 170.938 263.063 177.293 265.75 183C266.291 184.149 266.913 185.272 267.629 186.405L340.129 212.405C326.129 253.405 326.629 282.905 331.629 330.405C247.667 345.627 195.591 343.855 111.629 327.905Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_upper_chest)"
        @mouseover="activeArea = areas.front_upper_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M174.629 186.405C179.197 177.805 180.67 171.941 181.129 159.405C214.437 184.448 232.103 183.417 262.129 159.405C262.371 170.938 263.063 177.293 265.75 183M174.629 186.405L103.129 213.405C117.129 255.905 118.129 282.905 111.629 327.905C195.591 343.855 247.667 345.627 331.629 330.405C326.629 282.905 326.129 253.405 340.129 212.405L267.629 186.405C266.913 185.272 266.291 184.149 265.75 183M174.629 186.405C171.237 193.236 169.723 196.425 168 200.5M265.75 183C267.605 188.272 268.645 191.228 270.5 196.5M210 196.5C209.807 202.269 209.188 205.117 206.5 209M214.5 218C221.54 218.489 225.291 217.463 231.5 212.405M141.5 212.405C157.5 218 190.5 215.3 192.5 222.5M246 222.5C262.129 222.5 292 212.405 300 218"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_right_upper_arm)"
        @mouseover="activeArea = areas.front_right_upper_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        stroke="black"
        :fill="
          data.front_right_upper_arm.selected
            ? areas.front_right_upper_arm.activeColor
            : areas.front_right_upper_arm.inactiveColor
        "
        :class="{ active: data.front_right_upper_arm.selected, hovered: activeArea == areas.front_right_upper_arm }"
        class="ax-selectable"
        d="M330.5 349L388.159 309.405C387.543 301.278 387.412 295.706 388.159 277.905C385.347 238.122 375.16 224.374 340.659 212.405C317.159 281.905 333 323 330.5 349Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_right_middle_arm)"
        @mouseover="activeArea = areas.front_right_middle_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        stroke="black"
        :fill="
          data.front_right_middle_arm.selected
            ? areas.front_right_middle_arm.activeColor
            : areas.front_right_middle_arm.inactiveColor
        "
        :class="{ active: data.front_right_middle_arm.selected, hovered: activeArea == areas.front_right_middle_arm }"
        class="ax-selectable"
        d="M399.233 416.405C394.733 390.905 401.371 349.184 387.733 309.405L332.233 348.905C331.623 362.232 330.891 369.029 329.733 381.405C336.733 392.905 329.733 408.405 340.733 433.405L399.233 416.405Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_lower_chest)"
        @mouseover="activeArea = areas.front_lower_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_lower_chest.selected ? areas.front_lower_chest.activeColor : areas.front_lower_chest.inactiveColor
        "
        :class="{ active: data.front_lower_chest.selected, hovered: activeArea == areas.front_lower_chest }"
        d="M186.129 633.905C155.129 633.905 131.129 633.905 102.629 602.405C100.329 569.917 107.122 544.041 112.74 520.5C116.893 503.102 120.404 486.979 119.129 470.405H324.129C322.192 491.222 326.466 503.836 331.108 520.5C336.055 538.259 341.419 560.618 340.129 602.405C324.129 631.405 306.629 633.905 258.129 633.905C258.129 615.905 242.629 598.405 223.129 598.405C199.629 597.905 186.129 617.455 186.129 633.905Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_lower_chest)"
        @mouseover="activeArea = areas.front_lower_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M218 508C220.002 506.253 223.997 506.346 226 508M112.74 520.5C116.893 503.102 120.404 486.979 119.129 470.405H324.129C322.192 491.222 326.466 503.836 331.108 520.5M112.74 520.5C107.122 544.041 100.329 569.917 102.629 602.405C131.129 633.905 155.129 633.905 186.129 633.905C186.129 617.455 199.629 597.905 223.129 598.405C242.629 598.405 258.129 615.905 258.129 633.905C306.629 633.905 324.129 631.405 340.129 602.405C341.419 560.618 336.055 538.259 331.108 520.5M112.74 520.5C110.5 536.5 114 539.5 119.129 547.5M331.108 520.5C331.35 535.877 329.86 541.847 324.129 547.5"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_middle_left_leg)"
        @mouseover="activeArea = areas.front_middle_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_middle_left_leg.selected
            ? areas.front_middle_left_leg.activeColor
            : areas.front_middle_left_leg.inactiveColor
        "
        :class="{ active: data.front_middle_left_leg.selected, hovered: activeArea == areas.front_middle_left_leg }"
        d="M129.629 1041.91C100.129 975.905 132.129 886.405 119.629 826.905H202.629C202.629 884.905 192.266 913.829 189.629 948.905C192.629 985.905 191.586 1017.2 189.629 1041.91H129.629Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_middle_left_leg)"
        @mouseover="activeArea = areas.front_middle_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M166.5 904.5C154.314 900.876 147.535 899.903 136 909.5M132.5 938.5C136.427 949.269 140.629 952.946 151.5 955.5M163.5 955.5C175 948.905 177.326 939.521 175 924.5M119.629 826.905C132.129 886.405 100.129 975.905 129.629 1041.91H189.629C191.586 1017.2 192.629 985.905 189.629 948.905C192.266 913.829 202.629 884.905 202.629 826.905H119.629Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_lower_left_leg)"
        @mouseover="activeArea = areas.front_lower_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_lower_left_leg.selected
            ? areas.front_lower_left_leg.activeColor
            : areas.front_lower_left_leg.inactiveColor
        "
        :class="{ active: data.front_lower_left_leg.selected, hovered: activeArea == areas.front_lower_left_leg }"
        d="M189.629 1041.91H129.629L146.129 1090.91C148.092 1097.66 148.624 1101.4 147.629 1107.91C145.508 1117.97 146.065 1122.49 149.629 1128.91C152.656 1135.61 153.5 1140 151 1148C147.406 1159.5 149.629 1164.5 144.5 1176C143.409 1180.36 138.498 1183.77 138.681 1186.5C137.678 1195.32 141.297 1197.44 147.629 1197.93C149.296 1201.18 152.936 1202.22 157.629 1201.91C160.918 1203.69 164.025 1203.79 167.5 1202.35C171.354 1204.23 175.231 1204.03 180.629 1201.91C189.697 1203.39 193.42 1199.61 193.5 1191.65C196.767 1182.08 194.74 1166.03 190.629 1143.91C194.129 1113.91 187.129 1110.91 185.629 1094.91L189.629 1041.91Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_lower_left_leg)"
        @mouseover="activeArea = areas.front_lower_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M180.629 1201.91C176.879 1193.79 176.915 1188.1 180.629 1176M180.629 1201.91C175.231 1204.03 171.354 1204.23 167.5 1202.35M180.629 1201.91C189.697 1203.39 193.42 1199.61 193.5 1191.65C196.767 1182.08 194.74 1166.03 190.629 1143.91C194.129 1113.91 187.129 1110.91 185.629 1094.91L189.629 1041.91H129.629L146.129 1090.91C148.092 1097.66 148.624 1101.4 147.629 1107.91C145.508 1117.97 146.065 1122.49 149.629 1128.91C152.656 1135.61 153.5 1140 151 1148C147.406 1159.5 149.629 1164.5 144.5 1176C143.409 1180.36 138.498 1183.77 138.681 1186.5C137.678 1195.32 141.297 1197.44 147.629 1197.93M157.629 1201.91C160.918 1203.69 164.025 1203.79 167.5 1202.35M157.629 1201.91C155.709 1196.4 156.177 1193.04 160 1186.5M157.629 1201.91C152.936 1202.22 149.296 1201.18 147.629 1197.93M167.5 1202.35C165.879 1195.31 166.096 1191.48 169.5 1185M147.629 1197.93C146.893 1193.13 147.962 1190.29 152 1185M184.5 1197.93C187.163 1197.22 185.697 1198.74 189 1193.93M172 1197.93C174.343 1198.92 173.156 1198.96 175.5 1197.93M160 1197.93C161.758 1198.95 161.741 1198.93 163.5 1197.93M151 1195.5C152.29 1196.96 151.765 1196.4 153.5 1196.5M143 1190C143.65 1192.25 142.924 1191.66 144.5 1192"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_lower_right_leg)"
        @mouseover="activeArea = areas.front_lower_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_lower_right_leg.selected
            ? areas.front_lower_right_leg.activeColor
            : areas.front_lower_right_leg.inactiveColor
        "
        :class="{ active: data.front_lower_right_leg.selected, hovered: activeArea == areas.front_lower_right_leg }"
        d="M254.494 1042H314.494L297.994 1091C296.031 1097.76 295.499 1101.49 296.494 1108C298.615 1118.06 298.057 1122.58 294.494 1129C291.466 1135.7 290.623 1140.09 293.123 1148.09C296.716 1159.59 294.494 1164.59 299.623 1176.09C300.714 1180.46 305.625 1183.86 305.442 1186.59C306.445 1195.41 302.826 1197.54 296.494 1198.03C294.826 1201.27 291.187 1202.31 286.494 1202C283.205 1203.78 280.098 1203.88 276.623 1202.44C272.768 1204.32 268.891 1204.12 263.494 1202C254.426 1203.49 250.703 1199.71 250.623 1191.75C247.356 1182.17 249.383 1166.13 253.494 1144C249.994 1114 256.994 1111 258.494 1095L254.494 1042Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_lower_right_leg)"
        @mouseover="activeArea = areas.front_lower_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M263.494 1202C267.243 1193.89 267.208 1188.19 263.494 1176.09M263.494 1202C268.891 1204.12 272.768 1204.32 276.623 1202.44M263.494 1202C254.426 1203.49 250.703 1199.71 250.623 1191.75C247.356 1182.17 249.383 1166.13 253.494 1144C249.994 1114 256.994 1111 258.494 1095L254.494 1042H314.494L297.994 1091C296.031 1097.76 295.499 1101.49 296.494 1108C298.615 1118.06 298.057 1122.58 294.494 1129C291.466 1135.7 290.623 1140.09 293.123 1148.09C296.716 1159.59 294.494 1164.59 299.623 1176.09C300.714 1180.46 305.625 1183.86 305.442 1186.59C306.445 1195.41 302.826 1197.54 296.494 1198.03M286.494 1202C283.205 1203.78 280.098 1203.88 276.623 1202.44M286.494 1202C288.413 1196.5 287.945 1193.14 284.123 1186.59M286.494 1202C291.187 1202.31 294.826 1201.27 296.494 1198.03M276.623 1202.44C278.244 1195.4 278.026 1191.58 274.623 1185.09M296.494 1198.03C297.23 1193.23 296.16 1190.38 292.123 1185.09M259.623 1198.03C256.96 1197.32 258.425 1198.83 255.123 1194.03M272.123 1198.03C269.779 1199.02 270.967 1199.05 268.623 1198.03M284.123 1198.03C282.364 1199.05 282.382 1199.02 280.623 1198.03M293.123 1195.59C291.833 1197.06 292.357 1196.5 290.623 1196.59M301.123 1190.09C300.473 1192.34 301.198 1191.76 299.623 1192.09"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_middle_right_leg)"
        @mouseover="activeArea = areas.front_middle_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_middle_right_leg.selected
            ? areas.front_middle_right_leg.activeColor
            : areas.front_middle_right_leg.inactiveColor
        "
        :class="{ active: data.front_middle_right_leg.selected, hovered: activeArea == areas.front_middle_right_leg }"
        d="M314.061 1042C343.586 976 311.559 886.5 324.069 827H241C241 885 251.371 913.923 254.011 949C251.008 986 252.052 1017.29 254.011 1042H314.061Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_middle_right_leg)"
        @mouseover="activeArea = areas.front_middle_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M277.159 904.595C289.355 900.971 296.14 899.998 307.685 909.595M311.188 938.595C307.257 949.363 303.052 953.041 292.172 955.595M280.162 955.595C268.652 949 266.324 939.615 268.652 924.595M324.069 827C311.559 886.5 343.586 976 314.061 1042H254.011C252.052 1017.29 251.008 986 254.011 949C251.371 913.923 241 885 241 827H324.069Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_left_lower_arm)"
        @mouseover="activeArea = areas.front_left_lower_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_left_lower_arm.selected
            ? areas.front_left_lower_arm.activeColor
            : areas.front_left_lower_arm.inactiveColor
        "
        :class="{ active: data.front_left_lower_arm.selected, hovered: activeArea == areas.front_left_lower_arm }"
        d="M30.5 613.5C30.4999 552 21.129 493.905 44.1291 417.405L102.629 434.405C105.629 509.905 84.129 546.405 67.6291 593.905C65.9566 599.934 66.6608 604.216 68 609L30.5 613.5Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_left_lower_arm)"
        @mouseover="activeArea = areas.front_left_lower_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M58 446C69.8545 444.685 75.8932 445.661 84.5 453.5M44.1291 417.405C21.129 493.905 30.4999 552 30.5 613.5L68 609C66.6608 604.216 65.9566 599.934 67.6291 593.905C84.129 546.405 105.629 509.905 102.629 434.405L44.1291 417.405Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_left_hand)"
        @mouseover="activeArea = areas.front_left_hand"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="data.front_left_hand.selected ? areas.front_left_hand.activeColor : areas.front_left_hand.inactiveColor"
        :class="{ active: data.front_left_hand.selected, hovered: activeArea == areas.front_left_hand }"
        d="M68 609L30.5 613.5C24.1389 617.851 18.0835 623.524 14.8242 632.96C12.7934 645.566 2.06465 651.18 0.731987 661.507C2.50045 665.749 7.11852 666.062 12.0192 660.184L22.8706 644.292L23.6054 650.563C25.5499 672.584 19.9748 684.679 18.6371 705.813C19.2249 710.83 23.9817 713.451 28.5574 709.101C33.405 699.264 32.4974 691.578 34.4024 672.182C35.2157 668.273 40.3791 668.939 39.9332 675.984C39.7041 692.538 40.0701 698.852 40.1727 716.003C40.9075 722.274 47.5455 724.675 49.8727 717.409C50.3922 712.335 50.65 708.268 50.7375 704.5C50.9496 695.368 50.1612 687.993 49.6724 672.3C49.9321 669.091 53.6945 668.65 54.689 671.712L58.5308 704.5L59.5384 713.099C60.8267 718.669 68.4985 719.041 69.5714 711.923C67.4406 693.738 68.3667 685.366 66.2359 667.181C66.569 664.599 69.0038 663.678 70.6253 666.666C72.5858 678.95 73.6277 683.631 74.7792 696.692C76.6212 701.562 82.3383 701.527 83.5582 695.663C82.7591 681.176 82.5395 675.531 79.3701 659.921C75.3239 636.239 79.3899 624.829 68 609Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_left_hand)"
        @mouseover="activeArea = areas.front_left_hand"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M28.5574 648C38.3731 644.054 42.2424 639.817 44.5 626.5M42.5 666.666C48.5855 660.653 52.2528 659.433 59.5384 663.5M42.5 704.5C46.0133 703.574 47.8759 703.389 50.7375 704.5M50.7375 704.5C50.9496 695.368 50.1612 687.993 49.6724 672.3C49.9321 669.091 53.6945 668.65 54.689 671.712L58.5308 704.5M50.7375 704.5C50.65 708.268 50.3922 712.335 49.8727 717.409C47.5455 724.675 40.9075 722.274 40.1727 716.003C40.0701 698.852 39.7041 692.538 39.9332 675.984C40.3791 668.939 35.2157 668.273 34.4024 672.182C32.4974 691.578 33.405 699.264 28.5574 709.101C23.9817 713.451 19.2249 710.83 18.6371 705.813C19.9748 684.679 25.5499 672.584 23.6054 650.563L22.8706 644.292L12.0192 660.184C7.11852 666.062 2.50045 665.749 0.731987 661.507C2.06465 651.18 12.7934 645.566 14.8242 632.96C18.0835 623.524 24.1389 617.851 30.5 613.5L68 609C79.3899 624.829 75.3239 636.239 79.3701 659.921C82.5395 675.531 82.7591 681.176 83.5582 695.663C82.3383 701.527 76.6212 701.562 74.7792 696.692C73.6277 683.631 72.5858 678.95 70.6253 666.666C69.0038 663.678 66.569 664.599 66.2359 667.181C68.3667 685.366 67.4406 693.738 69.5714 711.923C68.4985 719.041 60.8267 718.669 59.5384 713.099L58.5308 704.5M58.5308 704.5C60.7425 703.338 62.3836 702.976 66.2359 703"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_right_hand)"
        @mouseover="activeArea = areas.front_right_hand"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_right_hand.selected ? areas.front_right_hand.activeColor : areas.front_right_hand.inactiveColor
        "
        :class="{ active: data.front_right_hand.selected, hovered: activeArea == areas.front_right_hand }"
        d="M374 607.5L411.5 612C418.141 615.91 424.341 621.649 428.231 630.842C431.11 643.282 442.195 648.157 444.223 658.37C442.745 662.722 438.159 663.347 432.872 657.814L420.97 642.693L420.661 648.999C420.211 671.101 426.592 682.791 429.357 703.786C429.11 708.831 424.541 711.768 419.681 707.737C414.179 698.252 414.565 690.522 411.352 671.299C410.276 667.454 405.169 668.468 406.091 675.466C407.44 691.967 407.502 698.291 408.56 715.41C408.251 721.716 401.791 724.561 398.977 717.469C398.292 713.473 397.815 710.101 397.477 707C396.357 696.746 396.748 689.467 396.125 672.45C395.649 669.266 391.865 669.081 391.08 672.203L389.042 713.822C388.134 719.467 380.505 720.358 378.952 713.328C379.848 695.041 378.357 686.75 379.253 668.463C378.746 665.91 376.254 665.156 374.839 668.247C373.957 677.959 373.322 682.971 372.961 691C372.862 693.212 372.783 695.653 372.726 698.485C371.218 703.468 365.511 703.821 363.898 698.053C363.715 683.545 363.552 677.898 365.658 662.108C368.092 638.207 363.707 624.063 374 607.5Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_right_hand)"
        @mouseover="activeArea = areas.front_right_hand"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M418 645.5C407.259 640.591 401.376 637.701 398.977 624.5M374.839 658.37C383.786 658.114 388.477 658.361 392.5 664M366.5 690C369.434 689.288 370.948 689.24 372.961 691M372.961 691C372.862 693.212 372.783 695.653 372.726 698.485C371.218 703.468 365.511 703.821 363.898 698.053C363.715 683.545 363.552 677.898 365.658 662.108C368.092 638.207 363.707 624.063 374 607.5L411.5 612C418.141 615.91 424.341 621.649 428.231 630.842C431.11 643.282 442.195 648.157 444.223 658.37C442.745 662.722 438.159 663.347 432.872 657.814L420.97 642.693L420.661 648.999C420.211 671.101 426.592 682.791 429.357 703.786C429.11 708.831 424.541 711.768 419.681 707.737C414.179 698.252 414.565 690.522 411.352 671.299C410.276 667.454 405.169 668.468 406.091 675.466C407.44 691.967 407.502 698.291 408.56 715.41C408.251 721.716 401.791 724.561 398.977 717.469C398.292 713.473 397.815 710.101 397.477 707M372.961 691C373.322 682.971 373.957 677.959 374.839 668.247C376.254 665.156 378.746 665.91 379.253 668.463C378.357 686.75 379.848 695.041 378.952 713.328C380.505 720.358 388.134 719.467 389.042 713.822L391.08 672.203C391.865 669.081 395.649 669.266 396.125 672.45C396.748 689.467 396.357 696.746 397.477 707M397.477 707C400.944 705.201 402.692 704.858 405 707"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_middle_chest)"
        @mouseover="activeArea = areas.front_middle_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_middle_chest.selected
            ? areas.front_middle_chest.activeColor
            : areas.front_middle_chest.inactiveColor
        "
        :class="{ active: data.front_middle_chest.selected, hovered: activeArea == areas.front_middle_chest }"
        d="M323.629 470.405H119.129C119.129 386.905 106.629 356.405 112.129 327.905C199.129 344.405 247.129 345.405 331.629 330.405C335.629 359.405 324.129 394.405 323.629 470.405Z"
      />
      <circle
        @click="eventClickOnGerericAreas(areas.genitalia)"
        @mouseover="activeArea = areas.genitalia"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="data.genitalia.selected ? areas.genitalia.activeColor : areas.genitalia.inactiveColor"
        :class="{ active: data.genitalia.selected, hovered: activeArea == areas.genitalia }"
        cx="222.129"
        cy="634.405"
        r="35.5"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_upper_right_leg)"
        @mouseover="activeArea = areas.front_upper_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_upper_right_leg.selected
            ? areas.front_upper_right_leg.activeColor
            : areas.front_upper_right_leg.inactiveColor
        "
        :class="{ active: data.front_upper_right_leg.selected, hovered: activeArea == areas.front_upper_right_leg }"
        d="M323.629 826.905C340.629 765.405 334.629 697.905 340.629 602.405C311.629 632.905 293.629 633.905 257.129 633.905C257.129 655.405 238.629 669.905 226.129 669.905C236.687 730.922 238.282 765.72 240.629 826.905H323.629Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_upper_left_leg)"
        @mouseover="activeArea = areas.front_upper_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_upper_left_leg.selected
            ? areas.front_upper_left_leg.activeColor
            : areas.front_upper_left_leg.inactiveColor
        "
        :class="{ active: data.front_upper_left_leg.selected, hovered: activeArea == areas.front_upper_left_leg }"
        d="M119.629 826.905C102.629 765.405 108.629 697.905 102.629 602.405C131.629 632.905 149.629 633.905 186.129 633.905C186.129 655.405 204.629 669.905 217.129 669.905C206.571 730.922 204.976 765.72 202.629 826.905H119.629Z"
      />
    </svg>
    <svg
      :height="height"
      :width="width"
      fill="none"
      viewBox="0 0 422 1200"
      xmlns="http://www.w3.org/2000/svg"
      :style="[{ 'pointer-events': readOnly ? 'none' : 'fill' }]"
    >
      <path
        @click="eventClickOnGerericAreas(areas.back_right_lower_arm)"
        @mouseover="activeArea = areas.back_right_lower_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_right_lower_arm.selected
            ? areas.back_right_lower_arm.activeColor
            : areas.back_right_lower_arm.inactiveColor
        "
        :class="{ active: data.back_right_lower_arm.selected, hovered: activeArea == areas.back_right_lower_arm }"
        d="M411.926 612C411.926 550.5 422.659 492.905 399.659 416.405L341.159 433.405C338.159 508.905 359.659 545.405 376.159 592.905C377.832 598.934 375.765 602.716 374.426 607.5L411.926 612Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_right_lower_arm)"
        @mouseover="activeArea = areas.back_right_lower_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M380.5 443.5L376.5 442M399.659 416.405C422.659 492.905 411.926 550.5 411.926 612L374.426 607.5C375.765 602.716 377.832 598.934 376.159 592.905C359.659 545.405 338.159 508.905 341.159 433.405L399.659 416.405Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_left_upper_arm)"
        @mouseover="activeArea = areas.back_left_upper_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_left_upper_arm.selected
            ? areas.back_left_upper_arm.activeColor
            : areas.back_left_upper_arm.inactiveColor
        "
        :class="{ active: data.back_left_upper_arm.selected, hovered: activeArea == areas.back_left_upper_arm }"
        d="M114 350L56.055 310.405C56.6707 302.278 56.8024 296.706 56.055 278.905C58.8676 239.122 69.4988 224.969 104 213C127.5 282.5 111 326 114 350Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_left_middle_arm)"
        @mouseover="activeArea = areas.back_left_middle_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_left_middle_arm.selected
            ? areas.back_left_middle_arm.activeColor
            : areas.back_left_middle_arm.inactiveColor
        "
        :class="{ active: data.back_left_middle_arm.selected, hovered: activeArea == areas.back_left_middle_arm }"
        d="M44.555 417.405C49.055 391.905 42.4172 350.184 56.055 310.405L114 350C114.61 363.327 115 370 115.5 382.5C108.5 394 114.055 409.405 103.055 434.405L44.555 417.405Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.head)"
        @mouseover="activeArea = areas.head"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="data.head.selected ? areas.head.activeColor : areas.head.inactiveColor"
        :class="{ active: data.head.selected, hovered: activeArea == areas.head }"
        d="M251.055 6.90544C267.134 16.9357 272.782 22.7849 280.055 33.4054C283.222 38.5721 288.155 56.6054 282.555 87.4054C286.955 83.0054 289.88 87.8993 290.055 88.9054C293.794 110.405 279.555 117.405 280.055 124.905C280.055 127.905 278.655 133.805 273.055 133.405C271.5 140 270.5 144.5 270 146.5C266.701 148.874 263.541 151.045 260.5 153.017C259.487 153.674 258.487 154.308 257.5 154.921C254.433 156.825 251.487 158.517 248.642 160C247.922 160.375 247.208 160.738 246.5 161.086C242.128 163.24 237.989 164.887 234 166.041C230.572 167.032 227.256 167.66 224 167.932C223.163 168.002 222.33 168.049 221.5 168.072C218.135 168.166 214.821 167.877 211.5 167.216C208.684 166.655 205.862 165.826 203 164.735C202.124 164.402 201.244 164.043 200.359 163.661C196.995 162.205 193.56 160.398 190 158.248C189.01 157.65 188.011 157.026 187 156.376C185.525 155.426 184.026 154.421 182.5 153.36C179.917 151.564 177.256 149.61 174.5 147.5C174 146 173.582 140.705 171.182 133.905C165.582 134.305 164.182 128.405 164.182 125.405C164.682 117.905 150.442 110.905 154.182 89.4053C154.357 88.3992 157.282 83.5054 161.682 87.9054C156.082 57.1054 161.015 39.072 164.182 33.9054C171.454 23.2848 177.103 17.4356 193.182 7.40538C216.63 -1.07376 229.289 -1.02672 251.055 6.90544Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.head)"
        @mouseover="activeArea = areas.head"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M282.555 87.4054C288.155 56.6054 283.222 38.5721 280.055 33.4054C272.782 22.7849 267.134 16.9357 251.055 6.90544C229.289 -1.02672 216.63 -1.07376 193.182 7.40538C177.103 17.4356 171.454 23.2848 164.182 33.9054C161.015 39.072 156.082 57.1054 161.682 87.9054M282.555 87.4054C286.955 83.0054 289.88 87.8993 290.055 88.9054C293.794 110.405 279.555 117.405 280.055 124.905C280.055 127.905 278.655 133.805 273.055 133.405M282.555 87.4054C282.555 104.5 276 114.5 273.055 133.405M273.055 133.405C271.5 140 270.5 144.5 270 146.5C266.701 148.874 263.541 151.045 260.5 153.017M161.682 87.9054C157.282 83.5054 154.357 88.3992 154.182 89.4053C150.442 110.905 164.682 117.905 164.182 125.405C164.182 128.405 165.582 134.305 171.182 133.905M161.682 87.9054C160.429 106.103 167.5 115 171.182 133.905M171.182 133.905C173.582 140.705 174 146 174.5 147.5C177.256 149.61 179.917 151.564 182.5 153.36M189 117.5C190.874 121.036 192.832 122.737 197.5 125.405M242 122.5C246 106 261 102 263 69.5M204.5 32C201.5 48 195.5 56.5 197.5 73M181 142.5C180.637 147.126 181.163 149.423 182.5 153.36M182.5 153.36C184.026 154.421 185.525 155.426 187 156.376M190 149C188.373 152.294 188.698 154.382 190 158.248M190 158.248C193.56 160.398 196.995 162.205 200.359 163.661M190 158.248C189.01 157.65 188.011 157.026 187 156.376M201 152.5C199.886 156.987 199.733 159.433 200.359 163.661M200.359 163.661C201.244 164.043 202.124 164.402 203 164.735M211.5 162C212.166 164.037 212.064 165.179 211.5 167.216M211.5 167.216C214.821 167.877 218.135 168.166 221.5 168.072M211.5 167.216C208.684 166.655 205.862 165.826 203 164.735M235 155.5C235.52 160.381 235.219 162.62 234 166.041M234 166.041C237.989 164.887 242.128 163.24 246.5 161.086M234 166.041C230.572 167.032 227.256 167.66 224 167.932M221.5 158.248C220.524 162.873 220.71 164.873 221.5 168.072M221.5 168.072C222.33 168.049 223.163 168.002 224 167.932M246.5 151C247.227 155.305 247.546 157.673 246.5 161.086M246.5 161.086C247.208 160.738 247.922 160.375 248.642 160M242 152.5C243.421 154.179 242.964 156.223 242 160M260 137C257.5 145 260.185 148.571 257.5 154.921M257.5 154.921C258.487 154.308 259.487 153.674 260.5 153.017M257.5 154.921C254.433 156.825 251.487 158.517 248.642 160M207 153.5C205.813 155.935 205.574 156.987 206 158.248M195.5 147C194.306 152.006 194.49 153.607 195.5 155.5M261.5 142C260.178 144.473 262 148.5 260.5 153.017M249 154C249.206 156.646 249.112 157.944 248.642 160M224 162C223.116 164.701 223.09 166.01 224 167.932M203 157C201.981 160.215 201.998 161.909 203 164.735M187 150.5C186.4 152.892 186.416 154.178 187 156.376"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_upper_chest)"
        @mouseover="activeArea = areas.back_upper_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_upper_chest.selected ? areas.back_upper_chest.activeColor : areas.back_upper_chest.inactiveColor
        "
        :class="{ active: data.back_upper_chest.selected, hovered: activeArea == areas.back_upper_chest }"
        d="M268.055 186.405L340.555 212.405C335.084 229.289 332.813 238.953 330 256.5C237.445 277.086 206.055 277.217 113.5 256.5C111.986 239.787 109.793 230.248 104 213L175.055 186.405C185.92 178.775 180.415 161.012 174.5 147.5C211 177 232.5 173.5 270 146.5C263.992 159.808 258.836 179.213 268.055 186.405Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_upper_chest)"
        @mouseover="activeArea = areas.back_upper_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M194.5 198C201.897 206.957 203.93 213.195 205.5 225.5M243 225.5C240.948 215.819 243.611 211.482 251 204.5M104 213L175.055 186.405C185.92 178.775 180.415 161.012 174.5 147.5C211 177 232.5 173.5 270 146.5C263.992 159.808 258.836 179.213 268.055 186.405L340.555 212.405C335.084 229.289 332.813 238.953 330 256.5C237.445 277.086 206.055 277.217 113.5 256.5C111.986 239.787 109.793 230.248 104 213Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_right_upper_arm)"
        @mouseover="activeArea = areas.back_right_upper_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_right_upper_arm.selected
            ? areas.back_right_upper_arm.activeColor
            : areas.back_right_upper_arm.inactiveColor
        "
        :class="{ active: data.back_right_upper_arm.selected, hovered: activeArea == areas.back_right_upper_arm }"
        d="M330.5 349L388.159 309.405C387.543 301.278 387.412 295.706 388.159 277.905C385.347 238.122 375.16 224.374 340.659 212.405C317.159 281.905 333 323 330.5 349Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_right_middle_arm)"
        @mouseover="activeArea = areas.back_right_middle_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_right_middle_arm.selected
            ? areas.back_right_middle_arm.activeColor
            : areas.back_right_middle_arm.inactiveColor
        "
        :class="{ active: data.back_right_middle_arm.selected, hovered: activeArea == areas.back_right_middle_arm }"
        d="M399.659 416.405C395.159 390.905 401.797 349.184 388.159 309.405L330.5 349C329.5 362.5 329 368.5 328 381C335 392.5 330.159 408.405 341.159 433.405L399.659 416.405Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_lower_chest)"
        @mouseover="activeArea = areas.back_lower_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_lower_chest.selected ? areas.back_lower_chest.activeColor : areas.back_lower_chest.inactiveColor
        "
        :class="{ active: data.back_lower_chest.selected, hovered: activeArea == areas.back_lower_chest }"
        d="M322 504.5C242.144 524.431 197.697 524.372 119 504.5C121.5 477.5 115 437 117.5 408.5C203.5 423 241.5 421 326 408.5C326 440 318 477.5 322 504.5Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_lower_chest)"
        @mouseover="activeArea = areas.back_lower_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M220 449V469M119 504.5C197.697 524.372 242.144 524.431 322 504.5C318 477.5 326 440 326 408.5C241.5 421 203.5 423 117.5 408.5C115 437 121.5 477.5 119 504.5Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_middle_left_leg)"
        @mouseover="activeArea = areas.back_middle_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_middle_left_leg.selected
            ? areas.back_middle_left_leg.activeColor
            : areas.back_middle_left_leg.inactiveColor
        "
        :class="{ active: data.back_middle_left_leg.selected, hovered: activeArea == areas.back_middle_left_leg }"
        d="M130.055 1041.91C100.555 975.905 133.5 860 121 800.5H203C203 858.5 192.692 913.829 190.055 948.905C193.055 985.905 192.012 1017.2 190.055 1041.91H130.055Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_middle_left_leg)"
        @mouseover="activeArea = areas.back_middle_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M140.5 894C154.268 891.699 161.179 893.353 172.5 899.405M121 800.5C133.5 860 100.555 975.905 130.055 1041.91H190.055C192.012 1017.2 193.055 985.905 190.055 948.905C192.692 913.829 203 858.5 203 800.5H121Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_lower_left_leg)"
        @mouseover="activeArea = areas.back_lower_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_lower_left_leg.selected
            ? areas.back_lower_left_leg.activeColor
            : areas.back_lower_left_leg.inactiveColor
        "
        :class="{ active: data.back_lower_left_leg.selected, hovered: activeArea == areas.back_lower_left_leg }"
        d="M190.055 1041.91H130.055L146.555 1090.91C148.518 1097.66 149.05 1101.4 148.055 1107.91C145.934 1117.97 146.491 1122.49 150.055 1128.91C153.082 1135.61 153.746 1139.47 150.055 1146.91C139.5 1161.5 120 1167.5 126.5 1177C126.5 1177 142.301 1181.9 153 1181.83C163.342 1186.79 180.935 1184.66 191.055 1177C192.555 1172 194.688 1154.24 191.055 1143.91C194.555 1113.91 187.555 1110.91 186.055 1094.91L190.055 1041.91Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_lower_left_leg)"
        @mouseover="activeArea = areas.back_lower_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M182 1124C178.5 1132 178.5 1143.91 178.5 1146.91M153 1181.83C163.342 1186.79 180.935 1184.66 191.055 1177C192.555 1172 194.688 1154.24 191.055 1143.91C194.555 1113.91 187.555 1110.91 186.055 1094.91L190.055 1041.91H130.055L146.555 1090.91C148.518 1097.66 149.05 1101.4 148.055 1107.91C145.934 1117.97 146.491 1122.49 150.055 1128.91C153.082 1135.61 153.746 1139.47 150.055 1146.91C139.5 1161.5 120 1167.5 126.5 1177C126.5 1177 142.301 1181.9 153 1181.83ZM153 1181.83C149.741 1177.2 148.419 1174.05 150.055 1164"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_lower_right_leg)"
        @mouseover="activeArea = areas.back_lower_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_lower_right_leg.selected
            ? areas.back_lower_right_leg.activeColor
            : areas.back_lower_right_leg.inactiveColor
        "
        :class="{ active: data.back_lower_right_leg.selected, hovered: activeArea == areas.back_lower_right_leg }"
        d="M254.002 1042H314.002L297.502 1091C295.539 1097.76 295.007 1101.49 296.002 1108C298.123 1118.06 297.566 1122.58 294.002 1129C290.974 1135.7 290.311 1139.57 294.002 1147C304.557 1161.59 324.057 1167.59 317.557 1177.09C317.557 1177.09 301.756 1181.99 291.057 1181.93C280.715 1186.89 263.122 1184.75 253.002 1177.09C251.502 1172.09 249.369 1154.33 253.002 1144C249.502 1114 256.502 1111 258.002 1095L254.002 1042Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_lower_right_leg)"
        @mouseover="activeArea = areas.back_lower_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M262.057 1124.09C265.557 1132.09 265.557 1144 265.557 1147M291.057 1181.93C280.715 1186.89 263.122 1184.75 253.002 1177.09C251.502 1172.09 249.369 1154.33 253.002 1144C249.502 1114 256.502 1111 258.002 1095L254.002 1042H314.002L297.502 1091C295.539 1097.76 295.007 1101.49 296.002 1108C298.123 1118.06 297.566 1122.58 294.002 1129C290.974 1135.7 290.311 1139.57 294.002 1147C304.557 1161.59 324.057 1167.59 317.557 1177.09C317.557 1177.09 301.756 1181.99 291.057 1181.93ZM291.057 1181.93C294.316 1177.3 295.637 1174.14 294.002 1164.09"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_middle_right_leg)"
        @mouseover="activeArea = areas.back_middle_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_middle_right_leg.selected
            ? areas.back_middle_right_leg.activeColor
            : areas.back_middle_right_leg.inactiveColor
        "
        :class="{ active: data.back_middle_right_leg.selected, hovered: activeArea == areas.back_middle_right_leg }"
        d="M314.055 1041.91C343.555 975.905 313 861 325.5 801.5H243.5C243.5 859.5 251.418 913.829 254.055 948.905C251.055 985.905 252.098 1017.2 254.055 1041.91H314.055Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_middle_right_leg)"
        @mouseover="activeArea = areas.back_middle_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M273.5 898.5C285.427 892.115 292.711 890.752 307.5 895M325.5 801.5C313 861 343.555 975.905 314.055 1041.91H254.055C252.098 1017.2 251.055 985.905 254.055 948.905C251.418 913.829 243.5 859.5 243.5 801.5H325.5Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_left_lower_arm)"
        @mouseover="activeArea = areas.back_left_lower_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_left_lower_arm.selected
            ? areas.back_left_lower_arm.activeColor
            : areas.back_left_lower_arm.inactiveColor
        "
        :class="{ active: data.back_left_lower_arm.selected, hovered: activeArea == areas.back_left_lower_arm }"
        d="M30.926 613.5C30.9259 552 21.555 493.905 44.5552 417.405L103.055 434.405C106.055 509.905 84.555 546.405 68.0552 593.905C66.3826 599.934 67.0869 604.216 68.426 609L30.926 613.5Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_left_lower_arm)"
        @mouseover="activeArea = areas.back_left_lower_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M71 448L74 445M44.5552 417.405C21.555 493.905 30.9259 552 30.926 613.5L68.426 609C67.0869 604.216 66.3826 599.934 68.0552 593.905C84.555 546.405 106.055 509.905 103.055 434.405L44.5552 417.405Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_left_hand)"
        @mouseover="activeArea = areas.back_left_hand"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="data.back_left_hand.selected ? areas.back_left_hand.activeColor : areas.back_left_hand.inactiveColor"
        :class="{ active: data.back_left_hand.selected, hovered: activeArea == areas.back_left_hand }"
        d="M68.426 609L30.926 613.5C24.5649 617.851 18.5095 623.524 15.2502 632.96C13.2194 645.566 2.49067 651.18 1.15801 661.507C2.92648 665.749 7.54455 666.062 12.4452 660.184L23.2966 644.292L24.0314 650.563C25.976 672.584 20.4008 684.679 19.0631 705.813C19.6509 710.83 24.4077 713.451 28.9834 709.101C33.831 699.264 32.9234 691.578 34.8284 672.182C35.6417 668.273 40.8052 668.939 40.3593 675.984C40.1302 692.538 40.4961 698.852 40.5988 716.003C41.3335 722.274 47.9716 724.675 50.2987 717.409C52.0772 700.038 50.7889 694.468 50.0984 672.3C50.3581 669.091 54.1205 668.65 55.115 671.712L59.9644 713.099C61.2527 718.669 68.9245 719.041 69.9975 711.923C67.8667 693.738 68.7927 685.366 66.6619 667.181C66.9951 664.599 69.4298 663.678 71.0514 666.666C73.0118 678.95 74.0538 683.631 75.2053 696.692C77.0472 701.562 82.7643 701.527 83.9842 695.663C83.1851 681.176 82.9656 675.531 79.7961 659.921C75.7499 636.239 79.8159 624.829 68.426 609Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_right_hand)"
        @mouseover="activeArea = areas.back_right_hand"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="data.back_right_hand.selected ? areas.back_right_hand.activeColor : areas.back_right_hand.inactiveColor"
        :class="{ active: data.back_right_hand.selected, hovered: activeArea == areas.back_right_hand }"
        d="M374.426 607.5L411.926 612C418.567 615.91 424.767 621.649 428.657 630.842C431.537 643.282 442.621 648.157 444.649 658.37C443.172 662.722 438.585 663.347 433.298 657.814L421.396 642.693L421.087 648.999C420.637 671.101 427.018 682.791 429.783 703.786C429.536 708.831 424.967 711.768 420.107 707.737C414.606 698.252 414.991 690.522 411.778 671.299C410.702 667.454 405.595 668.468 406.517 675.466C407.866 691.967 407.928 698.291 408.986 715.41C408.677 721.716 402.217 724.561 399.403 717.469C396.453 700.258 397.362 694.613 396.551 672.45C396.075 669.266 392.291 669.081 391.506 672.203L389.468 713.822C388.56 719.467 380.931 720.358 379.378 713.328C380.274 695.041 378.784 686.75 379.679 668.463C379.172 665.91 376.68 665.156 375.265 668.247C374.14 680.635 373.417 685.376 373.152 698.485C371.644 703.468 365.937 703.821 364.324 698.053C364.141 683.545 363.978 677.898 366.084 662.108C368.518 638.207 364.133 624.063 374.426 607.5Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_middle_chest)"
        @mouseover="activeArea = areas.back_middle_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_middle_chest.selected ? areas.back_middle_chest.activeColor : areas.back_middle_chest.inactiveColor
        "
        :class="{ active: data.back_middle_chest.selected, hovered: activeArea == areas.back_middle_chest }"
        d="M112.5 328C116.11 300.076 116.282 284.421 113.5 256.5C198.165 274.361 244.01 274.283 330 256.5C327.5 285 329 300 332 328L326 408.5C243.257 421.773 197.592 421.908 117.5 408.5L112.5 328Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_middle_chest)"
        @mouseover="activeArea = areas.back_middle_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M208 289C209.721 303.254 209.4 298.746 208 313C201.135 328.122 194.21 335.118 177.5 345.5M239.5 295C234.976 309.254 235.593 309.246 239.5 323.5C250.068 346.083 252.805 343.272 263 349M113.5 256.5C116.282 284.421 116.11 300.076 112.5 328L117.5 408.5C197.592 421.908 243.257 421.773 326 408.5L332 328C329 300 327.5 285 330 256.5C244.01 274.283 198.165 274.361 113.5 256.5Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_upper_right_leg)"
        @mouseover="activeArea = areas.back_upper_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_upper_right_leg.selected
            ? areas.back_upper_right_leg.activeColor
            : areas.back_upper_right_leg.inactiveColor
        "
        :class="{ active: data.back_upper_right_leg.selected, hovered: activeArea == areas.back_upper_right_leg }"
        d="M337.5 685.5C339.595 616.197 338.394 576.432 322 504.5C286.5 512 262.5 518.5 221 519V641V689.5C221.879 736.865 235.243 760.408 243.5 801.5H325.5C332.537 758.954 335.056 733.428 337.5 685.5Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_upper_right_leg)"
        @mouseover="activeArea = areas.back_upper_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M221 641C254.052 653.954 283.385 656.834 318.5 641M221 641V689.5C221.879 736.865 235.243 760.408 243.5 801.5H325.5C332.537 758.954 335.056 733.428 337.5 685.5C339.595 616.197 338.394 576.432 322 504.5C286.5 512 262.5 518.5 221 519V641Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_upper_left_leg)"
        @mouseover="activeArea = areas.back_upper_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_upper_left_leg.selected
            ? areas.back_upper_left_leg.activeColor
            : areas.back_upper_left_leg.inactiveColor
        "
        :class="{ active: data.back_upper_left_leg.selected, hovered: activeArea == areas.back_upper_left_leg }"
        d="M104.778 685C102.683 615.697 102.606 576.432 119 504.5C154.5 512 179.5 518.5 221 519L221.278 640.5V689C220.399 736.365 211.257 759.408 203 800.5H121C113.963 757.954 107.222 732.928 104.778 685Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_upper_left_leg)"
        @mouseover="activeArea = areas.back_upper_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M221.278 640.5C188.226 653.454 158.893 656.334 123.778 640.5M221.278 640.5V689C220.399 736.365 211.257 759.408 203 800.5H121C113.963 757.954 107.222 732.928 104.778 685C102.683 615.697 102.606 576.432 119 504.5C154.5 512 179.5 518.5 221 519L221.278 640.5Z"
        stroke="black"
      />
    </svg>
    <v-tooltip :value="!!activeArea" :position-x="tooltipPositionX" :position-y="tooltipPositionY" top>
      {{ tooltiplabel }}
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    height: String,
    width: String,
    value: Object,
    readOnly: Boolean,
  },
  computed: {
    tooltiplabel() {
      return this.activeArea?.label || ''
    },
  },
  methods: {
    buildEmptyDataObject() {
      return Object.values(this.areas).reduce(
        (acc, option) => ({
          ...acc,
          [option.key]: { selected: false, label: option.label },
        }),
        {},
      )
    },
    setPosition(e) {
      this.tooltipPositionX = e.clientX
      this.tooltipPositionY = e.clientY
    },
    eventClickOnGerericAreas(clickedArea) {
      this.data[clickedArea.key].selected = !this.data[clickedArea.key].selected
      if (this.data[clickedArea.key].selected) {
        this.data.area_total += clickedArea.weight
      } else {
        this.data.area_total -= clickedArea.weight
      }
      this.$emit('input', this.data)
    },
  },
  mounted() {
    this.data = { ...this.buildEmptyDataObject(), ...this.value, area_total: this.totalWeight }
    this.isMounted = true
  },
  data() {
    return {
      totalWeight: 0,
      isMounted: false,
      activeColor: '#ff0000',
      inactiveColor: '#fff',
      data: null,
      tooltipPositionX: null,
      tooltipPositionY: null,
      activeArea: null,
      areas: {
        face: {
          key: 'face',
          label: 'Face',
          selected: false,
          activeColor: 'rgba(25, 243, 191, 0.5)',
          inactiveColor: '#e0e0e0',
          weight: 4.5,
        },
        head: {
          key: 'head',
          label: 'Cabeça',
          selected: false,
          activeColor: 'rgba(25, 243, 191, 0.5)',
          inactiveColor: '#e0e0e0',
          weight: 4.5,
        },
        front_right_lower_arm: {
          key: 'front_right_lower_arm',
          label: 'Braço posterior inferior direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        front_right_upper_arm: {
          key: 'front_right_upper_arm',
          label: 'Braço posterior superior direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        front_right_middle_arm: {
          key: 'front_right_middle_arm',
          label: 'Braço posterior médio direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        front_left_lower_arm: {
          key: 'front_left_lower_arm',
          label: 'Braço posterior inferior esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        front_left_upper_arm: {
          key: 'front_left_upper_arm',
          label: 'Braço posterior superior esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        front_left_middle_arm: {
          key: 'front_left_middle_arm',
          label: 'Braço posterior médio esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        back_right_lower_arm: {
          key: 'back_right_lower_arm',
          label: 'Braço anterior inferior direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        back_right_upper_arm: {
          key: 'back_right_upper_arm',
          label: 'Braço anterior superior direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        back_right_middle_arm: {
          key: 'back_right_middle_arm',
          label: 'Braço anterior médio direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        back_left_lower_arm: {
          key: 'back_left_lower_arm',
          label: 'Braço anterior inferior esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        back_left_upper_arm: {
          key: 'back_left_upper_arm',
          label: 'Braço anterior superior esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        back_left_middle_arm: {
          key: 'back_left_middle_arm',
          label: 'Braço anterior médio esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        front_right_hand: {
          key: 'front_right_hand',
          label: 'Palma da mão direita',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1,
        },
        back_right_hand: {
          key: 'back_right_hand',
          label: 'Dorço da mão direita',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1,
        },
        front_left_hand: {
          key: 'front_left_hand',
          label: 'Palma da mão esquerda',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1,
        },
        back_left_hand: {
          key: 'back_left_hand',
          label: 'Dorço da mão esquerda',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1,
        },
        front_upper_chest: {
          key: 'front_upper_chest',
          label: 'Peito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 6,
        },
        front_middle_chest: {
          key: 'front_middle_chest',
          label: 'Tórax',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 6,
        },
        front_lower_chest: {
          key: 'front_lower_chest',
          label: 'Barriga',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 6,
        },
        back_upper_chest: {
          key: 'back_upper_chest',
          label: 'Pescoço',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 6,
        },
        back_middle_chest: {
          key: 'back_middle_chest',
          label: 'Costas',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 6,
        },
        back_lower_chest: {
          key: 'back_lower_chest',
          label: 'Lombar',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 6,
        },
        genitalia: {
          key: 'genitalia',
          label: 'Genitália',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1,
        },
        back_upper_right_leg: {
          key: 'back_upper_right_leg',
          label: 'Coxa anterior direita',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 3,
        },
        back_middle_right_leg: {
          key: 'back_middle_right_leg',
          label: 'Joelho anterior direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 3,
        },
        back_lower_right_leg: {
          key: 'back_lower_right_leg',
          label: 'Pé anterior direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 3,
        },
        back_upper_left_leg: {
          key: 'back_upper_left_leg',
          label: 'Coxa anterior esquerda',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 3,
        },
        back_middle_left_leg: {
          key: 'back_middle_left_leg',
          label: 'Joelho anterior esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 3,
        },
        back_lower_left_leg: {
          key: 'back_lower_left_leg',
          label: 'Pé anterior esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 3,
        },
        front_upper_right_leg: {
          key: 'front_upper_right_leg',
          label: 'Coxa posterior direita',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 3,
        },
        front_middle_right_leg: {
          key: 'front_middle_right_leg',
          label: 'Joelho posterior direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 3,
        },
        front_lower_right_leg: {
          key: 'front_lower_right_leg',
          label: 'Pé posterior direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 3,
        },
        front_upper_left_leg: {
          key: 'front_upper_left_leg',
          label: 'Coxa posterior esquerda',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 3,
        },
        front_middle_left_leg: {
          key: 'front_middle_left_leg',
          label: 'Joelho posterior esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 3,
        },
        front_lower_left_leg: {
          key: 'front_lower_left_leg',
          label: 'Pé posterior esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 3,
        },
      },
    }
  },
}
</script>

<style scoped>
.areas {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.ax-selectable {
  cursor: pointer;
  transition: all 0.1s ease-in-out;
}
.ax-selectable.hovered:not(.active) {
  fill: #9c9c9c;
}
.ax-label {
  position: fixed;
  background: #aaa021;
  color: white;
  padding: 4px 14px;
  font-size: 0.8rem;
  border-radius: 8px;
  box-shadow: 0 0 3px 0 #3a3a3a42;
  user-select: none;
}
.ax-thumbnails {
  display: flex;
}
.ax-thumbnails .ax-thumbs .ax-thumb-item {
  height: 106px;
  width: 106px;
  border-radius: 5px;
  background: #e8e8e870;
  margin: 1rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
}
.ax-thumbnails .ax-thumbs .ax-thumb-item:before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.ax-thumbnails .ax-thumbs .ax-thumb-item.active {
  border: 2px solid #aba022;
}
.ax-thumbnails .ax-thumbs .ax-thumb-item:hover {
  border: 2px solid rgba(171, 160, 34, 0.6);
}
.ax-thumbnails .ax-thumbs .ax-thumb-item:first-of-type {
  margin-top: 0;
}
.ax-selected-areas {
  padding: 1rem 1.8rem;
  border-left: 1px solid #dee2e6;
  width: 250px;
}
.ax-selected-areas > p {
  font-weight: bold;
}
.ax-selected-areas > ul {
  list-style: none;
  padding: 0;
  margin: 1.4rem 0;
}
.ax-selected-areas > ul > li {
  display: flex;
  justify-content: space-between;
  margin: 0 0 0.8rem;
}
.ax-selected-areas > ul > li > span {
  width: 100%;
}
.ax-selected-areas > ul > li > i {
  color: #e0e0e0;
  cursor: pointer;
}
.items-questions {
  align-self: center;
  height: fit-content;
}

.icon-page {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-7%);
  transform: translateY(-50%);
}

.answer-areas {
  background: #f6f6f6;
  padding-top: 0.1rem;
  padding-bottom: 0.7rem;
  margin-top: 0.5rem !important;
}

.answer-areas-position {
  margin-left: 40px;
}

.answer-text-position {
  margin-left: 25px;
}

body {
  color: #636c72;
}

body nick-checkbox .form-group,
.page-router-container nick-checkbox .form-group {
  margin: 0 !important;
  float: left;
  height: auto;
}

.form-group {
  margin-bottom: 0rem;
}

.page-router-container .nick-radio-options .nick-radio-option {
  width: 33.3333%;
  margin: 0px;
}

.ax-selected-areas {
  width: 300px;
}

label {
  margin-bottom: 0px;
}

.modal-dialog {
  max-width: 650px;
}

#items-wrapper {
  width: 100%;
}

#items {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

.item {
  flex: none;
  width: 100%;
  height: 100%;
  scroll-snap-align: start;
  pointer-events: none;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
